import { useSelector } from 'react-redux';
import { Col, Row } from 'antd';

import { cardResponsive } from 'shared/constants/breakpoints';
import { NotificationComponent } from 'shared/components/Notifications/NotificationComponent';
import PageLayout from 'shared/components/PageLayout';
import NewVisitCard from 'shared/components/Cards/NewVisitCard';
import { VisitsList } from 'shared/components/VisitsList';
import {
  getAppConfigSelector,
  getWhiteLabelAffiliateSelector
} from 'store/app/app.redux';
import { getUserSelector } from 'store/user/user.redux';
import { useTranslationCustom } from 'shared/utils/hooks/useTranslationCustom';

const HIDE_DASHBOARD_WIDGETS_AFFILIATE_ID =
  'aff::b3b5c422-0620-4868-83bc-d7bcfad6ac30';

const DashBoard = () => {
  const appConfig = useSelector(getAppConfigSelector);
  const user = useSelector(getUserSelector);
  const whiteLabelAffiliate = useSelector(getWhiteLabelAffiliateSelector);
  const t = useTranslationCustom();

  const hideWidgets =
    whiteLabelAffiliate?.id === HIDE_DASHBOARD_WIDGETS_AFFILIATE_ID;

  const formattedName = `${user?.firstName
    .charAt(0)
    .toUpperCase()}${user?.firstName.slice(1).toLowerCase()}`;

  return (
    <PageLayout
      titleProps={{
        description: t(
          'dashboard.description',
          'This is your personal dashboard on {{appName}}. Here you’ll find all the information regarding your medical consultations.',
          { appName: appConfig.appName }
        ),
        title: t('dashboard.title', 'Welcome, {{formattedName}}', {
          formattedName
        }),
        linkHref: '#'
      }}
    >
      <Row gutter={[30, 16]}>
        <Col
          {...(hideWidgets
            ? { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 }
            : cardResponsive)}
        >
          <NewVisitCard />
        </Col>
        {!hideWidgets && (
          <Col {...cardResponsive}>
            <NotificationComponent dashboard={true} />
          </Col>
        )}
      </Row>

      {!hideWidgets && (
        <VisitsList
          title={t('dashboard.resentConsultations', 'Recent Consultations')}
          preview={true}
        />
      )}
    </PageLayout>
  );
};

export default DashBoard;
